<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">Praca</h2>
                        <p class="card-description">Lista pozycji pracy</p>
                        <b-button variant="primary" class="mt-4 mb-4" @click="$router.push('/work-item/new')">
                            {{ $t('createNewTitle') }}
                        </b-button>
                        <b-table
                            striped
                            hover
                            :items="workItems"
                            :fields="fields"
                            @row-clicked="editWorkItem"
                            class="clickable"
                        ></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import { Const } from '../../../main'

export default {
    name: 'WorkItemList',
    data() {
        return {
            workItems: [],
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    thStyle: 'width: 75px;'
                },
                {
                    key: 'title',
                    label: this.$t('forms.title'),
                    sortable: true
                },
                {
                    key: 'titleEn',
                    label: 'Title EN',
                    sortable: true
                },
                {
                    key: 'city',
                    label: this.$t('forms.city'),
                    sortable: true
                },
                {
                    key: 'url',
                    label: 'URL',
                    sortable: true
                },
                {
                    key: 'displayOrder',
                    label: this.$t('forms.order'),
                    sortable: true
                }
            ]
        }
    },
    mounted() {
        axios.get(Const.API_HOST + '/admin/workItems')
            .then(function (response) {
                return response.data
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            }).then(body => {
                this.workItems = body
            })
    },
    methods: {
        editWorkItem(item) {
            this.$router.push('/work-item/edit/' + item.id)
        }
    }
}
</script>

<style scoped>
.clickable /deep/ tbody td {
    cursor: pointer;
}
</style>
